module.exports = __webpack_public_path__ + "img/bang2.c6da23ff.png";